import {ILargeFileWizardState} from "../../../types/ui/wizard/large-file";

export const initialLargeFileState: ILargeFileWizardState = {
  boxIds: []
};
